import { render, staticRenderFns } from "./DashboardIncome.vue?vue&type=template&id=0f62fde8&scoped=true&"
import script from "./DashboardIncome.vue?vue&type=script&lang=js&"
export * from "./DashboardIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62fde8",
  null
  
)

export default component.exports